export const whitelist = [
  {
    path: '/subsidiarylist',
    label: '子公司列表',
    sort: '1-1',
    hidden: false,
    showMenus: false,
    component: () => import('@/views/whitelist/subsidiary')
  },
  {
    path: '/whitelist',
    label: '管理员列表',
    sort: '1-2',
    hidden: false,
    showMenus: false,
    component: () => import('@/views/whitelist/index')
  }
]
